import { useEffect, useState } from "react";
import heroImage from "../assets/hero.jpg";
import g1 from "../assets/gallery1.jpg";
import g2 from "../assets/gallery2.jpg";
import g3 from "../assets/gallery3.jpg";

export default function Hero() {
  const slides = [heroImage, g1, g2, g3];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(id);
  }, [slides.length]);

  return (
    <section className="relative">
      <div className="relative h-[60vh] md:h-[70vh] w-full overflow-hidden">
        {/* Slides */}
        {slides.map((src, i) => (
          <div
            key={i}
            className={`absolute inset-0 transition-opacity duration-[1200ms] ease-in-out hero-slide ${i === index ? "opacity-100" : "opacity-0"}`}
            style={{
              backgroundImage: `url(${src})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        ))}
        <div className="absolute inset-0 overlay-gradient" />
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container">
            <div className="max-w-3xl mx-auto text-white text-center">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight text-shadow-lg text-white">
                Sri Venkateswara Degree & PG College, Nellore
              </h1>
              <p className="mt-4 text-lg md:text-xl text-neutral-100 text-shadow-lg">
                "Imparting Knowledge, Building Character, Serving Society"
              </p>
              {/* Dots */}
              <div className="mt-6 flex items-center justify-center gap-2">
                {slides.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIndex(i)}
                    aria-label={`Go to slide ${i + 1}`}
                    className={`h-2.5 w-2.5 rounded-full transition-all ${
                      i === index ? "bg-white w-6" : "bg-white/60 hover:bg-white/90"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
